<template>
  <div  v-if="body_show">
    <!-- 动态加载组件 -->
    <component :data="data" :is="isComponent"></component>
  </div>
</template>
<script>
import { courseprepare } from "@/api/course"
import { getSessionStorage } from '@/utils/tools'
import { shareCon } from "@/utils/wxconfig"
import buy_success1 from "./buy_success1"
import buy_success2 from "./buy_success2"
export default {
  data() {
      return {
        data: {},
        body_show:false,
        isComponent:''
      }
    },
    components:{
      buy_success1,
      buy_success2
    },
    methods: {
      pullData() {
        // 加载等待Loading
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        courseprepare({
            cid: this.$route.query.cid
          })
          .then((data) => {
            // 判断是哪一个课（bid为1或2）
            if(data.bid===2 || getSessionStorage('request','/bid') && getSessionStorage('request','/bid')==2){
              this.isComponent = buy_success2;
            }else{
              this.isComponent = buy_success1;
            }
            this.data = data;
            document.title = data.bigCourseName;
            
            this.$toast.clear();
            this.body_show = true;
          })

      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>

</style>